<template>
  <!--上传下载generic-->
  <div id="userImport">
    <a-modal
            title="Import"
            :visible="visible"
            width="60%"
            @cancel="cancelModal"
            :maskClosable="maskClosable"
            cancelText="-"
            okText="-"
    >
      <template slot="footer">
        <a-row type="flex" justify="end">
          <function-bar ></function-bar>
        </a-row>
      </template>

     
    <!--选择module 本地上传-->
      <div >
        <a-row>
          <label>{{$t('generic.TemplateName')}}: </label>
         <a-input   style="width: 250px" class="ml4" size="small" value="User import template" :disabled="true" /> 
        </a-row>

        <a-row class='mt4' type="flex" justify="start" >
          <a-col>
            <span class="file">{{ $t('reportSetting.Upload')}}
              <input class="sbxs bgc" id="uploadEventFile" accept=".csv,.txt, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"  ref="importExcelRef" v-on:change="fileChange($event)" type="file">
            </span>
          </a-col>

          <a-col class="ml4">{{updataExcelName}}</a-col>
          <a-col style="margin-left: 4px;">
            <a-button type="primary" @click="importDownload" size="small">{{ $t('publicLang.Download') }}</a-button>
          </a-col>

        </a-row>
      </div>
    </a-modal>


    <!--上传报错提示-->
    <a-modal v-model="upErrorInfo" :title="$t('publicLang.AlertMessage')" :footer="null" width="50%">
      <a-alert type="error">
        <div slot="description" style="height: 50vh;overflow-y: auto;">
          <a-row v-for="(item,index) in upErrordata" class="infoError" :style="{background: index%2 ==0 ? '#efefef': '#fff',padding: '0 10px'}">
            <span  >{{item}}</span>
          </a-row>
        </div>
      </a-alert>
      <a-row  type="flex" justify="end">
        <a-button class="mt4" type="primary" size="small" @click="errorUpload" v-if="iFexcelFileBtn">Download</a-button>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import functionBar from "../components/functionBar.vue";
    import axios from "axios";
    import cookie from "../../../api/cookie";

    export default {
        components: {
            functionBar
        },
        props: {
            visible: {
                type: Boolean,
                default: function() {
                    return false;
                }
            },

        },
  
        data() {
            return {
                     maskClosable: false, // 关闭遮罩
                     updataExcelName: '', // 上传成功文件名
                     upErrorInfo:false, // 上转报错弹窗
                     upErrordata: [], // 报错信息
                     iFexcelFileBtn: true,
            };
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        methods: {
          errorUpload(){
              let str = this.upErrordataStr
              let strName = ''
              if(str.indexOf('@') > 0){
                  strName = (str.split('@')[1]).split('excelFileName=')[1]
              }
              let ajaxurl = ajax.ajaxUrl();
              let that = this
              that.$store.commit("updataLoading", { pbLoading: true });
              axios.get(ajaxurl + api.GENERICEXPORTEXCELERROR, {
                  params: {
                      excelFileName: strName,
                  },
                  headers: {
                      Authorization: cookie.getBearerToken()
                  },
                  responseType: "blob" //二进制流
              }).then(function (res) {
                  that.$store.commit("updataLoading", { pbLoading: false });
                  let data = res.data;
                  let fileReader = new FileReader();
                  fileReader.onload = function() {
                      try {
                          let jsonData = JSON.parse(this.result);
                          if (jsonData.code) {
                              that.$customMessage.warning(jsonData.msg);
                          }
                      } catch (err) {
                          that.downLoadBlobFile(res.data, 'excel', false);
                      }
                  };
                  fileReader.readAsText(data)
              })
          },
          downLoadBlobFile (data, fileName, type) { //type为Mime类型
            let name = fileName || new Date().toLocaleDateString();
            let typeStr = type ? type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
            if (window.navigator.msSaveOrOpenBlob) {  //兼容性处理
                const blob = new Blob([data], { type: typeStr });
                navigator.msSaveBlob(blob, name);
            } else {
                const excelBlob = new Blob([data], { type: typeStr });
                let oa = document.createElement('a');
                oa.href = URL.createObjectURL(excelBlob);
                oa.download = name;
                document.body.appendChild(oa);
                oa.click();
            }
         },
          excenModuleCodeChange(){
              this.$nextTick(()=>{
                  document.getElementById('uploadEventFile').value = ''
                  this.updataExcelName = ''
              })
          },
//      下载
            importDownload(){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.get(ajaxurl + api.EXPORTUSERTEMPLATE, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function (data) {
                    if (!data) {
                        return;
                    }
                    let blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", "excel.xlsx");
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                }).catch(function (error) {
                      alert(error);
                  });
            },


            importTemplateSelectChange(val){
                this.targetAdvanceTml = val
                this.currentVal = 1
                this.importAdvanuserSqlDto = {gmcUid: this.dataImport.gmcUid, template: this.targetAdvanceTml}
                this.initData()
            },

            //      上转excel
            fileChange(el) {
                let params = {}
                let file = event.target.files[0]; // 获取上传excel
                this.updataExcelName = file.name
                this.upErrordata = []
                ajax.post(api.IMPORTUSERTEMPLATE, params, "chardimportExcelImport", file).then(res => {
                    this.$refs.importExcelRef.value = ''
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.$emit("cancelImport", "init");
//                          this.updataExcelName = ''
// //                        上传成功后返回字符串 父表请求要带上
//                         if(typeof (res.data) == 'string' && parseInt(res.msg) < 1000){
//                             let topMenu = JSON.parse(sessionStorage.getItem("menu"))
//                             let topMenuActive = sessionStorage.getItem("menuActive")
//                             for(let i in topMenu){
//                                 if(topMenu[i].key == topMenuActive){
//                                     topMenu[i].importUids = res.data
//                                 }
//                             }
//                             sessionStorage.setItem("menu", JSON.stringify(topMenu));
//                             this.$emit("cancelImport", "init");
//                         }else{
//                             this.$emit("cancelImport", "init");
//                         }
                    } else {
                              this.$refs.importExcelRef.value = ''
                        if(typeof (res.data) == 'string'){
                            let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                            let topMenuActive = sessionStorage.getItem("menuActive")
                            for(let i in topMenu){
                                if(topMenu[i].key == topMenuActive){
                                    topMenu[i].importUids = res.data
                                }
                            }
                            sessionStorage.setItem("menu", JSON.stringify(topMenu));
                            this.$emit("cancelImport", "init");
                        }
                        this.upErrordataStr = res.msg
                        if (this.upErrordataStr.indexOf('@excelFileName') > 0){
                            this.iFexcelFileBtn = true
                        }else{
                            this.iFexcelFileBtn = false
                        }
                        let data = res.msg
                        if(data.split('@')){
                            data = data.split('@')[0]
                        }
                         data = data.split('//')
                         data = Array.from(new Set(data))
                         this.upErrordata = data
                         this.upErrorInfo = true
                    }
                });
            },

            //      import 编辑弹窗返回值
     GETcancelModalVisible(val) {
                this.eddvisible = false;
                this.$emit("cancelImport", "init");
            },
            
            //            弹窗取消
            cancelModal() {      
              this.$emit("cancelImport", "close");
              document.getElementById('uploadEventFile').value = ''  
              this.updataExcelName = ''  
            },
        }
    };
</script>
<style lang="less">
.bgc{
     background-color: #2b9ed6;
}
  .example {
    text-align: center;
    border-radius: 4px;
    padding: 80px 50px;
    margin: 20px 0;
  }
</style>
